import React from "react";
import HeroSection from "./HeroSection";

function Home() {

    return (
        <div className="items-center align-center bg-orange-500 h-[700px]">
            <HeroSection />
        </div>
    )
}

export default Home;